module.exports = __webpack_public_path__ + "img/piggy-bank.efdfc01c.svg";